import { Message } from "./Message"

export class MessageQueue {
    private items: Message[]

    constructor() {
        this.items = []
    }

    public addMessage(type: string, title: string, message: string, duration: number): void {
        this.items.push(new Message(type, title, message, duration))
    }

    public alterMessage(index: number, message: string): void {
        const oldMessage = this.items[index]
        this.items[index] = new Message(oldMessage.type, oldMessage.title, message, oldMessage.duration)
    }

    public popMessage(): Message | undefined {
        return this.isEmpty() ? undefined : this.items.shift()
    }

    public peekNextMessage(): Message | undefined {
        return this.isEmpty() ? undefined : this.items[0]
    }

    public emptyItems(): void {
        this.items = []
    }

    public countItems(): number {
        return this.items.length
    }

    public findItem(type: string, title: string, duration: number): number | false {
        let index: number | false = false

        if (undefined === type || undefined === title || undefined === duration) {
            return false
        }

        this.items.forEach((item, itemNumber) => {
            if (type !== item.type || title !== item.title || duration !== item.duration) {
                return
            }

            index = itemNumber
        })

        return index
    }

    public isEmpty(): boolean {
        return !this.countItems()
    }

    public itemExists(index: number): boolean {
        return undefined !== this.items[index]
    }
}
